const MENU_ITEMS = ['published', 'drafts', 'comments'];

export { MENU_ITEMS as default };
